module.exports = __webpack_public_path__ + "static/media/Gehuropic.0e0c4c68.otf";